import { NavLink } from 'react-router-dom';
import { FOOTER_NAV, SITE } from '../data/site';
import { Reveal } from './motion';

export function Footer() {
  return (
    <footer className="siv-panel tone-void mx-auto mt-5 mb-4 w-full max-w-[92rem] px-5 pt-14 pb-9 sm:px-8 lg:px-14">
      <span aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-brand opacity-70" />

      <Reveal className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[minmax(0,1.4fr)_repeat(3,minmax(0,1fr))] lg:gap-8">
        <div>
          <p className="flex items-baseline gap-2.5 text-[1.15rem] font-extrabold tracking-tight">
            <span aria-hidden="true" className="inline-block size-2.5 rounded-[3px] bg-brand" />
            Startup Idea Validator
          </p>
          <p className="text-muted mt-4 max-w-[32ch] text-sm leading-[1.7]">
            {SITE.name}, by {SITE.owner}. {SITE.tagline}
          </p>
        </div>

        {FOOTER_NAV.map((group) => (
          <nav key={group.heading} aria-label={group.heading}>
            <h2 className="eyebrow text-accent">{group.heading}</h2>
            <ul className="mt-5 flex flex-col gap-1">
              {group.items.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    className={({ isActive }) =>
                      `nav-link inline-flex min-h-11 items-center text-[0.95rem] transition-colors duration-300 motion-reduce:transition-none ${
                        isActive ? 'text-text font-semibold' : 'text-muted hover:text-text'
                      }`
                    }
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </Reveal>

      <div className="mt-12 flex flex-col gap-2 border-t border-line pt-7 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-faint text-sm">
          © {new Date().getFullYear()} {SITE.owner}
        </p>
        <p className="font-mono text-faint text-xs tracking-wider">
          Audited figures last verified {SITE.auditDate}
        </p>
      </div>
    </footer>
  );
}
